export const RelatedContent = ({ className = "" }: { className?: string }) => {
  return (
    <div className={`${className}`}>
      <p className="text-sm font-semibold mb-8">Links to this note</p>
      <ul className="text-xs mb-4 grid sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-1 gap-x-8 gap-y-6">
        {[0, 1, 2, 3, 4, 5, 6].map((item) => (
          <li key={item}>
            <strong>Est ex deserunt esse ut pariatur quis fugiat id velit commodo</strong>
            <p className="mt-2">Ut anim fugiat laboris et eiusmod aliquip.</p>
          </li>
        ))}
      </ul>
    </div>
  );
};
